import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { ODataModel } from '../../interfaces/odata-model.interface';
import { OdataResponse } from '../../interfaces/online-only.interface';
import { EncodingUtilities } from '../../utilities/encoding-utilities';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { HttpUtilitiesService } from '../http-utilities/http-utilities.service';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';
import { OdataServiceInterface } from './odata.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataService implements OdataServiceInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly httpUtilities: HttpUtilitiesService,
        private readonly http: HttpClient,
    ) {}

    public deepInsertRequest(data: ODataModel, endpoint: string, identifier: string): Observable<unknown> {
        const computedEndpoint = ODataUtilities.removeLeadingSlash(endpoint);
        const payload = {
            Endpoint: computedEndpoint,
            TimeStamp: `${computedEndpoint}-${identifier}`,
            Json: EncodingUtilities.base64EncodeUnicode(JSON.stringify(data.getOutModel())),
        };
        const query = this.uriUtilities.getUriForContent() + ENDPOINTS.DeepInsertSet;
        const headers = this.httpUtilities.setHeadersForIdempotency(new HttpHeaders({}));
        return this.http.post<OdataResponse<unknown>>(query, payload, { headers }).pipe(
            map((response) => ODataUtilities.transformResponseDataToArray(response.d)),
            catchError((error) => {
                this.log.error(
                    'deepInsertRequest() - request error: ' +
                        JSON.stringify(error) +
                        ' - for Request: ' +
                        JSON.stringify(query),
                );
                return throwError(error);
            }),
        );
    }

    public postRequest(url: string, payload: ODataModel): Observable<unknown> {
        const headers = this.httpUtilities.setHeadersForIdempotency(new HttpHeaders({}));
        return this.http.post<OdataResponse<unknown>>(url, payload.getOutModel(), { headers }).pipe(
            map((response) => ODataUtilities.transformResponseDataToArray(response.d)),
            catchError((error) => {
                this.log.error(
                    '_postRequest - error (JSON): ',
                    JSON.stringify(error, Object.getOwnPropertyNames(error)),
                );
                this.log.error('_postRequest - error: ', error);
                return throwError(error);
            }),
        );
    }
}
